import { observer } from "mobx-react-lite";
import { ReactElement, useEffect, useState, useRef } from "react";
import { useStore } from "../../root-store-context";
import { Button, Flex, Space, Spin } from "antd";
import "./BVHowToGuide.scss";

const BVHowToGuide = observer((): ReactElement => {
    const { apiStore } = useStore();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [src, setSrc] = useState<string>("");
    const objectUrlRef = useRef<string>("");

    useEffect(() => {

        const load = async () => {
            try {
                const res = await apiStore.BoardVueApiClient.downloadBoardVueUserGuide();
                const blob = new Blob([res.data], { type: "application/pdf" });

                const url = URL.createObjectURL(blob);
                objectUrlRef.current = url;
                setSrc(url);
            } catch (err) {
                console.error("Failed to load BoardVue User Guide", err);
            } finally {
                setIsLoading(false);
            }
        };

        load();

        return () => {
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
                objectUrlRef.current = "";
            }
        };
   }, [apiStore.BoardVueApiClient]);

    return (
        <Spin spinning={isLoading}>
            <div className="bvHowToGuide">
                <Flex justify="space-between" wrap="wrap" align="center" gap="middle" className="bvHowToGuide__header">
                    <div className="bvHowToGuide__headerRow">
                        <Space className="bvHowToGuide__titleSpace">
                            <h2 className="bvHowToGuide__title">BoardVue - How to Guide</h2>
                        </Space>
                    </div>
                </Flex>
                <Button type="primary" disabled={!src} className="bvHowToGuide__openButton" onClick={()=>window.open(src, "_blank", "noopener,noreferrer")}>Open in new Tab</Button>
                <iframe src={src} title="User Guide" className="bvHowToGuide__viewer"></iframe>
            </div>
        </Spin>
    )
})

export default BVHowToGuide;
